import './main.scss'
import './components/wc'
import './scripts/general'